const amount = (cents, fallback, format) => Number(format(cents, fallback)) || 0;

/**
 * Kreditni korisnici firmi "više restorana" (telefon i računar): redovi korisnika sa brojem narudžbi, ukupnim
 * iznosom, potrošenim kreditom i stanjem, posle pretrage (ime ili ID), uz zbirove. Zahteva nasleđen stari tab
 * more-restaurants/tabs/ReportCreditTabUsers (users, formatMoneyFromTotals, majorityRestaurantCurrency, filters).
 */
export default {
  computed: {
    currencySuffix() {
      return this.majorityRestaurantCurrency ? ` (${this.majorityRestaurantCurrency})` : "";
    },
    allRows() {
      return this.users.map((user, index) => {
        const totals = user.totals || {};
        const name = this.toLatin(user.user_name || "");
        return {
          key: `${user.user_id}-${index}`,
          id: user.user_id,
          idText: String(user.user_id),
          name,
          initials: name
            .split(" ")
            .filter(Boolean)
            .map((part) => part.charAt(0))
            .slice(0, 2)
            .join(""),
          ordersCount: user.orders_count || 0,
          ordersTotal: amount(totals.orders_total_cents, totals.orders_total, this.formatMoneyFromTotals),
          spent: amount(totals.spent_on_credits_cents, totals.spent_on_credits, this.formatMoneyFromTotals),
          balance: amount(totals.current_credit_balance_cents, totals.current_credit_balance, this.formatMoneyFromTotals),
          source: user,
        };
      });
    },
    /** Korisnici posle pretrage, redom iz izveštaja. */
    matchedRows() {
      const search = this.filters.search;
      return search
        ? this.customSearch(this.allRows, [{ value: "name" }, { value: "idText" }], search)
        : this.allRows;
    },
    sums() {
      return this.matchedRows.reduce(
        (sums, row) => ({
          ordersCount: sums.ordersCount + row.ordersCount,
          ordersTotal: sums.ordersTotal + row.ordersTotal,
          spent: sums.spent + row.spent,
          balance: sums.balance + row.balance,
        }),
        { ordersCount: 0, ordersTotal: 0, spent: 0, balance: 0 }
      );
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("no_data");
    },
  },
};
